/**
 * @file   名琴轩
 * @create macaiqi 2025/07/23
 * @update 
 */
import React, { useState, useEffect } from 'react';
import cls from 'classnames'
import img1 from '../../assets/images/yzqs/bg1.png';
import img2 from '../../assets/images/yzqs/bg2.png';
import img3 from '../../assets/images/yzqs/bg3.png';
import talkimg from '../../assets/images/yzqs/talk.png'
import title from '../../assets/images/yzqs/qzqs-title.png';
import Introduce from './Introduce';
import { queryArchivesList } from '../../service';
import './index.scss'


export default function YZQS({ setToPage }) {
    let floor = ["三层", "二层", "首层"];
    const [floorAt, setFloorAt] = useState(2); //2 首层  1二层 0三层
    const [show, setShow] = useState();
    const [data, setData] = useState();
    const [showqin, setShowQin] = useState();  // 选中的琴
    useEffect(() => {
        queryArchivesList({
            resource: floorAt === 0 ? 'YZQS3' : floorAt === 1 ? "YZQS2" : "YZQS1",
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setData(res?.records || [])
        })
    }, [floorAt])
    return (
        <div className='common-page yzqs-page '>
            <div
                className="back"
                onClick={() => {
                    setToPage();
                }}
            />
            <div className="floor">
                {floor.map((item, index) => {
                    return (
                        <div
                            className={cls("item", { active: index === floorAt })}
                            key={index}
                            onClick={() => {
                                setFloorAt(index);
                            }}
                        >
                            {item}
                            <i></i>
                        </div>
                    );
                })}
            </div>

            <div className="imgbox">
                <img src={title} alt="" srcset="" className='titleimg' />

                {data?.map((item, index) => {
                    return (
                        <div
                            className="common-hot"
                            key={index}
                            style={{
                                top: item?.extension1,
                                left: item?.extension2,
                            }}
                            onClick={() => {
                                setShowQin(item.id)
                            }}
                        />
                    )
                })}
                {showqin && <Introduce showqin={showqin} setShowQin={setShowQin} />}
                {floorAt === 2 && <>
                    <img src={img1} alt="" className='bg' style={{ height: "67.5rem" }} />
                    <div
                        className="common-talk animate__animated animate__pulse animate__slower	 animate__infinite"
                        onClick={() => {
                            setShow("talk");
                        }}
                    />
                    <div
                        className="tosecend"
                        onClick={() => {
                            setFloorAt(1)
                        }}
                    ></div>

                    {/* 对话 */}
                    {show === "talk" && <div className="shade   animate__animated animate__fadeIn animate__fast">
                        <i
                            className="close"
                            onClick={() => {
                                setShow();
                            }}
                        ></i>
                        <img src={talkimg} alt="" style={{ width: "40.375rem", height: "19.75rem" }} />
                    </div>}
                </>}
                {floorAt === 1 && <>
                    <img src={img2} alt="" className='bg' style={{ height: "67.5rem" }} />

                    <div
                        className="toone"
                        onClick={() => {
                            setFloorAt(2)
                        }}
                    ></div>
                    <div
                        className="tothree"
                        onClick={() => {
                            setFloorAt(0)
                        }}
                    ></div>
                </>}
                {floorAt === 0 && <>
                    <img src={img3} alt="" className='bg' style={{ height: "67.5rem" }} />


                    <div
                        className="tosecend three"
                        onClick={() => {
                            setFloorAt(1)
                        }}
                    ></div>
                </>}


            </div>

        </div>
    )
}
